import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CustomTextField from "../custom/CustomTextField";
import { isBlank } from "../../utils/ValidationRules";
import CustomNumberField from "../custom/CustomNumberField";
import CustomButton from "../custom/CustomButton";
import CustomDatePicker from "../custom/CustomDatePicker";
import apiClient from "../../utils/apiClient";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";
import dayjs from "dayjs";

const EditPenelitianModal = ({ open, onClose, userId, researchId, onSuccess }) => {
  const [bidangPenelitian, setBidangPenelitian] = useState("");
  const [topik, setTopik] = useState("");
  const [mulaiPenelitian, setMulaiPenelitian] = useState("");
  const [sumberBiaya, setSumberBiaya] = useState("");
  const [budget, setBudget] = useState("");
  const [actual, setActual] = useState("");

  useEffect(() => {
    if (!open || !researchId) return;

    const fetchResearchData = async () => {
      try {
        const response = await apiClient.get(
          `/research/details?id=${researchId}&lecturerId=${userId}&is_deleted=0`
        );
        const data = response.data.data[0];
        setMulaiPenelitian(dayjs(data.tanggal_mulai));
        setBidangPenelitian(data.bidang);
        setTopik(data.topik);
        setSumberBiaya(data.research_budget[0]?.sumber_biaya || "");
        setBudget(data.research_budget[0]?.budget || "");
        setActual(data.research_budget[0]?.actual || "");
      } catch (err) {
        showErrorToast("Failed to fetch journal data");
      }
    };

    fetchResearchData();
  }, [researchId, userId, open]);

  const submitPenelitian = (event) => {
    event.preventDefault();
    Swal.fire({
      text: "Masukkan penelitian baru ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, masukan",
      cancelButtonText: "Tidak, jangan masukkan",
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .put(`/research`, {
            id: researchId,
            mulaiPenelitian: mulaiPenelitian,
            bidangPenelitian: bidangPenelitian,
            sumberBiaya: sumberBiaya,
            budget: budget,
            actual: actual,
            topik: topik,
          })
          .then((response) => {
            showSuccessToast(response.data.msg);
            onSuccess();
          })
          .catch((err) => {
            showErrorToast(err.response.data.msg);
          });
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Penelitian</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <Typography>
              Mulai Penelitian<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomDatePicker
              value={mulaiPenelitian}
              onChange={(event) => setMulaiPenelitian(event)}
              format={"DD/MM/YYYY"}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Bidang Penelitian<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={bidangPenelitian}
              rule={(value) => isBlank(value, "Bidang Penelitian")}
              onChange={(event) => setBidangPenelitian(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Topik Penelitian<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={topik}
              rule={(value) => isBlank(value, "Topik Penelitian")}
              onChange={(event) => setTopik(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Sumber Biaya<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              rule={(value) => isBlank(value, "Sumber Biaya")}
              value={sumberBiaya}
              onChange={(event) => setSumberBiaya(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Budget<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomNumberField
              rule={(value) => isBlank(value, "Budget")}
              value={budget}
              onChange={(event) => setBudget(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Actual Budget<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomNumberField
              value={actual}
              rule={(value) => isBlank(value, "Actual Budget")}
              onChange={(event) => setActual(event.target.value)}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomButton
              text="Submit"
              baseColor="#003158"
              hoverColor="#00213A"
              onClick={submitPenelitian}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EditPenelitianModal;
